// Dependencies
import { FC, MouseEventHandler } from "react";

// Components

// Styles
import {
  StyledItemName,
  StyledItemInfo,
  StyledItemIcon,
  StyledItemType,
  StyledItemTotal,
  StyledItemWrapper,
} from "./WalletItem.styled";

import { currencyFormat } from "~/utils";
import { WALLET_TYPE } from "~/enums";
import { IWalletType } from "~/types";

interface WalletItemProps {
  type: keyof IWalletType;
  name: string;
  currency: string;
  total: string;
  onClick: MouseEventHandler<HTMLDivElement>;
}

const WalletItem: FC<WalletItemProps> = ({
  type,
  name,
  currency,
  total,
  onClick,
}) => {
  return (
    <StyledItemWrapper
      onClick={onClick}
      sx={{ "&": { borderColor: WALLET_TYPE[type].themeColor } }}
    >
      <StyledItemInfo>
        <StyledItemName>{name}</StyledItemName>
        <StyledItemTotal>{currencyFormat(total, currency)}</StyledItemTotal>
      </StyledItemInfo>
      <StyledItemInfo>
        <StyledItemIcon src={WALLET_TYPE[type].icon} />
        <StyledItemType>{WALLET_TYPE[type].label}</StyledItemType>
      </StyledItemInfo>
    </StyledItemWrapper>
  );
};

export default WalletItem;
